// extracted by mini-css-extract-plugin
module.exports = {"animatedEllipsis":"style-module__animatedEllipsis___1IplE","ellipsisAnimation":"style-module__ellipsisAnimation___3dWGb","textDivider":"style-module__textDivider___3pauJ"};